module.exports = __webpack_public_path__ + "img/20230803.9b1907e2.png";